module.exports = __webpack_public_path__ + "img/front-6.d6159c6b.png";